/* Washington Diamond: Diamond Price Calculator page.
   Intent cards (wd-pc-calculator) and FAQ topic chips (wd-pc-faq).
   The calculator’s own script stays inline in its section. */
(function () {
  'use strict';

  if (window.WDPriceCalculator && window.WDPriceCalculator.loaded) return;
  window.WDPriceCalculator = { loaded: true };

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  /* Intent cards: a card opens its next step in place of the cards; "Choose a different option" brings them back. */
  function initChooser(root) {
    if (!root || root.hasAttribute('data-wd-pc-ready')) return;
    root.setAttribute('data-wd-pc-ready', '');

    var cards = root.querySelector('[data-wd-pc-cards]');
    var buttons = root.querySelectorAll('[data-wd-pc-intent]');
    var panels = root.querySelectorAll('[data-wd-pc-panel]');
    var current = null;

    function show(index, focus) {
      var panel = root.querySelector('[data-wd-pc-panel="' + index + '"]');
      if (!panel) return;
      each(panels, function (p) { p.hidden = p !== panel; });
      each(buttons, function (b) {
        b.setAttribute('aria-expanded', b.getAttribute('data-wd-pc-intent') === String(index) ? 'true' : 'false');
      });
      if (cards) cards.hidden = true;
      current = String(index);
      if (focus !== false) {
        var target = panel.querySelector('[data-wd-pc-focus]');
        if (target) target.focus();
      }
    }

    function reset(focus) {
      each(panels, function (p) { p.hidden = true; });
      each(buttons, function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (cards) cards.hidden = false;
      if (focus && current) {
        var button = root.querySelector('[data-wd-pc-intent="' + current + '"]');
        if (button) button.focus();
      }
      current = null;
    }

    root.addEventListener('click', function (event) {
      var pick = event.target.closest('[data-wd-pc-intent]');
      if (pick && root.contains(pick)) {
        show(pick.getAttribute('data-wd-pc-intent'));
        return;
      }
      var change = event.target.closest('[data-wd-pc-change]');
      if (change && root.contains(change)) reset(true);
    });

    root._wdPcShow = show;
    root._wdPcReset = reset;
    root.hidden = false;
  }

  /* FAQ topic chips: show one topic's questions, or all of them. Without the script, every question shows. */
  function initFaq(root) {
    if (!root || root.hasAttribute('data-wd-pc-ready')) return;
    root.setAttribute('data-wd-pc-ready', '');

    var chipRow = root.querySelector('[data-wd-pc-chips]');
    if (!chipRow) return;
    var chips = chipRow.querySelectorAll('[data-wd-pc-filter]');
    var groups = root.querySelectorAll('[data-wd-pc-topic]');
    var status = root.querySelector('[data-wd-pc-faq-status]');
    var statusText = root.getAttribute('data-status-text') || '';

    function filter(topic, announce) {
      var shown = 0;
      each(chips, function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-wd-pc-filter') === topic ? 'true' : 'false');
      });
      each(groups, function (group) {
        var match = topic === 'all' || group.getAttribute('data-wd-pc-topic') === topic;
        group.hidden = !match;
        if (match) shown += group.querySelectorAll('details').length;
      });
      if (announce && status && statusText) {
        status.textContent = statusText.replace('[count]', shown);
      }
    }

    chipRow.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-wd-pc-filter]');
      if (chip && chipRow.contains(chip)) filter(chip.getAttribute('data-wd-pc-filter'), true);
    });

    root._wdPcFilter = filter;
    chipRow.hidden = false;
  }

  function initAll(scope) {
    var base = scope || document;
    each(base.querySelectorAll('[data-wd-pc-chooser]'), initChooser);
    each(base.querySelectorAll('[data-wd-pc-faq]'), initFaq);
    if (base.matches && base.matches('[data-wd-pc-faq]')) initFaq(base);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Theme editor: re-init a reloaded section, open the next step of a selected intent block,
     and show all topics so a selected question is never filtered out. */
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var faq = event.target.closest('[data-wd-pc-faq]');
    if (faq && faq._wdPcFilter) {
      faq._wdPcFilter('all', false);
      if (event.target.tagName === 'DETAILS') event.target.open = true;
      return;
    }
    var root = event.target.closest('[data-wd-pc-chooser]');
    if (!root || !root._wdPcShow) return;
    var button = event.target.querySelector('[data-wd-pc-intent]');
    if (button) root._wdPcShow(button.getAttribute('data-wd-pc-intent'), false);
  });
  document.addEventListener('shopify:block:deselect', function (event) {
    var root = event.target.closest('[data-wd-pc-chooser]');
    if (root && root._wdPcReset) root._wdPcReset(false);
  });
})();
